<h3 class="body-400">Auto-approve outgoing statements</h3>
<mat-radio-group [formControl]="autoApproveControl">
  <mat-radio-button [value]="true"> Auto-approve and send all statements </mat-radio-button>
  <mat-radio-button [value]="false"> Require approval to send each statement </mat-radio-button>
</mat-radio-group>
